import { stateBuilder as builder } from './helpers/builder';

export default builder({
    date_of_birth: null,
    submitted: false,
    has_password: false,
    addon: {}
});



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Marketing/state.js